import { Chapter, FadeUp } from "./Reveal";

const STEPS = [
    {
        n: "01",
        name: "Audit",
        text: "We map your funnel, find the leaks, and pick the highest-leverage fixes first.",
    },
    {
        n: "02",
        name: "Build & Automate",
        text: "Websites, CRM–ERP, chatbots, voice agents, WhatsApp API, all built and wired together.",
    },
    {
        n: "03",
        name: "Manage & Scale",
        text: "We run the ads, content, and follow-up on retainer. You watch the pipeline grow.",
    },
];

const Process = () => (
    <section id="process" className="bg-mist py-24 md:py-32" data-testid="process-section">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
            <Chapter
                index="06"
                label="Process"
                title={["Three steps.", "No mystery."]}
            />

            <div className="grid md:grid-cols-3 gap-6 md:gap-10">
                {STEPS.map((step, i) => (
                    <FadeUp key={step.n} delay={i * 0.15}>
                        <div className="relative pt-16 md:pt-20" data-testid={`process-step-${i + 1}`}>
                            <span
                                className="absolute top-0 left-0 font-display font-bold text-7xl md:text-8xl text-stroke-navy select-none"
                                aria-hidden="true"
                            >
                                {step.n}
                            </span>
                            <div className="relative border-t-2 border-navy pt-8">
                                <h3 className="font-display font-semibold tracking-tight text-2xl md:text-3xl text-navy">
                                    {step.name}
                                </h3>
                                <p className="mt-4 text-base leading-relaxed text-slate-600">{step.text}</p>
                            </div>
                        </div>
                    </FadeUp>
                ))}
            </div>
        </div>
    </section>
);

export default Process;
